<template>
  <div class="down-time-container global_container_center">
    <div class="down-time-main global_container_center">
    <div class="down-time-text">倒计时</div>
    <div class="down-time-block global_container_center">
      <div class="down-time-number">{{ downTime>3?3:downTime }}</div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"down-time",
  props:{
    downTime:Number,
    default:3
  }
}
</script>
<style>
.down-time-container{
  height:100vh;
  width:100%;
  background:rgb(255,255,255,0.7);
  position: absolute;
  left:0;
  top:0;
  z-index:1003
}
.down-time-main{
  flex-direction: column
}
.down-time-text{
  font-size:60px;
  color:#008732;
  margin-bottom:45px;
  font-weight: 700;
}
.down-time-number{
  font-size:90px;
  color:#008732;
}
.down-time-block{
  border:5.25px solid #008732;
  height:210px;
  width:210px;
  border-radius: 210px;
  background: rgb(0,135,50,.1);

}
</style>